import { Back } from "../../../ui/icons";
import InputField from "./InputField";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useRef, useState} from "react";
import {changeUserName, getUser, patchPhotoUser} from "../../../store/authSlice";

const PersonalData = ({ setActiveTab, activeTab, isMobile }) => {
    const {user} = useSelector((store) => store.auth)
    const [formData, setFormData] = useState({
        first_name:"",
        last_name:""
    });
    const fileInputRef = useRef(null);
    const dispatch = useDispatch()
    const handleClick = () => {
        fileInputRef.current?.click();
    };
    const handleFileChange = (e) => {
        const file = Array.from(e.target.files)[0];
        dispatch(patchPhotoUser(file));
    };
    useEffect(() => {
        setFormData({first_name:user?.first_name,last_name:user?.last_name})
    }, []);
    const onChangeName = () => {
        dispatch(changeUserName({
             first_name:formData?.first_name,
            last_name:formData?.last_name,
        }))
    }

    return (
        <>
            <div className="flex items-center gap-5 pb-2 pl-5 shadow-md sm:shadow-none ">
                {activeTab && isMobile && (
                    <button
                        className="cursor-pointer"
                        onClick={() => setActiveTab(null)}
                    >
                        <Back />
                    </button>
                )}
                <p className='font-normal text-[18px]'>Account information</p>
            </div>
            <div className="px-5 pt-5">
                <div className='lg:flex sm:flex gap-10 items-center'>
                    <img src={user?.photo ? user?.photo : "./images/Profile/beg.png"} className='w-[50%] sm:w-[12%] m-auto rounded-[50%]' alt="" />
                    <div className='flex gap-2 pt-2 sm:gap-5 text-[#FFF] w-full'>
                            <button
                                className="py-2 rounded-xl sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#8C1C1C]"
                                onClick={handleClick}
                            >
                                Add photo
                            </button>
                            <input
                                type="file"
                                ref={fileInputRef}
                                className="hidden"
                                onChange={handleFileChange}
                            />
                            <button
                                className='py-2 rounded-xl  sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#BA7373]'>Delete
                                photo
                            </button>

                    </div>
                </div>
                <div className='w-full lg-flex sm:flex gap-5 pt-5'>
                    <InputField label='Surname' onChange={(e) => setFormData({...formData,first_name: e.target.value})} value={formData?.first_name} width={"100%"}/>
                    <InputField label='Name' value={formData?.last_name} onChange={(e) => setFormData({...formData,last_name: e.target.value})} width={"100%"}/>
                </div>
                <h2 className="pt-5 pb-2">Payment</h2>
                <div className='flex gap-2 sm:gap-5 text-[#FFF] w-full'>
                    <button className='py-2 rounded-xl sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#BA7373]'>VISA</button>
                    <button className='py-2 rounded-xl  sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#8C1C1C]'>Add card</button>
                    <button onClick={() => onChangeName()} className='py-2 rounded-xl  sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#8C1C1C]'>Change name</button>
                </div>


            </div>
            <button
                className='py-2 block sm:hidden rounded-xl sm:rounded-2xl font-semibold text-base w-[90%] sm:w-[30%] bg-[#402D1D] text-[#FFF]'
                style={{ position: 'absolute', bottom: '30px', left: "50%", transform: "translateX(-50%)" }}
            >
                Save information
            </button>

        </>
    );
};

export default PersonalData
